module.exports = __webpack_public_path__ + "static/media/Joshua_Patterson.db0e758c.png";